<template>
  <div class="d-flex align-center">
    <v-avatar class="mr-6" size="110">
      <v-img :src="require('@/assets/me.png')" alt="owner, Maurice Williams" />
    </v-avatar>
    <div class="d-flex flex-column">
      <span>{{ signoff }}</span>
      <span class="text-h6">Maurice Williams</span>
      <span class="caption">Founder, owner &amp; operator of Epic Receptionists</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    signoff: {
      type: String,
      default: () => 'Warmly,'
    }
  }
}
</script>
